module.exports = __webpack_public_path__ + "static/media/insect(35).40705366.PNG";